import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { STAFF_SELECTOR_PATH_DIVIDER } from './const';
import { message, Checkbox as SpaCheckbox } from '@tencent/spaui';
import React from 'react';
import { useMemoizedFn } from 'ahooks';
import classNames from 'classnames';
import { zhbErrorToast, ZhbWecomOpenData } from '@tencent/zhb-biz-react-ui';
import { COMMON_INTERNAL_ERROR_MSG } from '../../const';
export { message };
var refreshDtsChildren = function refreshDtsChildren(children, index) {
  if (index != null) {
    children[index] = _objectSpread({}, children[index]);
  }
};
var updateTreeDts = function updateTreeDts(option) {
  var dts = option.dts,
    deptIds = option.deptIds,
    usersList = option.usersList,
    deptInfoDict = option.deptInfoDict;
  var nextDts = _toConsumableArray(dts);
  var updateDts = function updateDts(dts, deptId, users) {
    var _iterator = _createForOfIteratorHelper(dts.entries()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          idx = _step$value[0],
          item = _step$value[1];
        if (item.type === 'dept') {
          var _ref = deptInfoDict[deptId] || {},
            deptValue = _ref.deptValue;
          if (!deptValue) {
            toastCommonError();
            return null;
          }
          if (deptValue === item.value) {
            item.children = [].concat(_toConsumableArray(item.children), _toConsumableArray(users));
            item.load_option = item.children.length ? 1 : 0;
            return idx;
          }
          if (item.children.length) {
            var index = updateDts(item.children, deptId, users);
            refreshDtsChildren(item.children, index);
            if (index != null) {
              return idx;
            }
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return null;
  };
  deptIds.forEach(function (deptId, idx) {
    var users = usersList[idx];
    var index = updateDts(nextDts, deptId, users);
    refreshDtsChildren(dts, index);
  });
  return nextDts;
};
export var getUserByDeptIds = function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(opt) {
    var dtsState, prevDeptIds, onLoadUserByDeptId, deptInfoDict, dts, userInfoDict, needLoadDeptIds, nextDtsState, usersList;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dtsState = opt.dtsState, prevDeptIds = opt.deptIds, onLoadUserByDeptId = opt.onLoadUserByDeptId;
          deptInfoDict = dtsState.deptInfoDict, dts = dtsState.dts, userInfoDict = dtsState.userInfoDict;
          needLoadDeptIds = prevDeptIds.filter(function (deptId) {
            var deptInfo = deptInfoDict[deptId];
            if (deptInfo == null) {
              var errMsg = "\u672A\u627E\u5230\u7528\u6237\u6240\u5728\u90E8\u95E8id, \u90E8\u95E8\u53EF\u80FD\u5DF2\u7ECF\u5220\u9664: ".concat(deptId);
              console.warn(errMsg);
              return false;
            }
            return !deptInfo.usersLoaded;
          });
          if (needLoadDeptIds.length) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", null);
        case 5:
          nextDtsState = _objectSpread(_objectSpread({}, dtsState), {}, {
            deptInfoDict: _objectSpread({}, dtsState.deptInfoDict)
          });
          _context.next = 8;
          return Promise.all(needLoadDeptIds.map(function (deptId) {
            return onLoadUserByDeptId(deptId).then(function (res) {
              var deptInfo = nextDtsState.deptInfoDict[deptId];
              if (!deptInfo) {
                var errMsg = "".concat(COMMON_INTERNAL_ERROR_MSG, ": StaffSelect dept id \u4E0D\u5B58\u5728-").concat(deptId);
                zhbErrorToast(errMsg);
                return [];
              }
              deptInfo.usersLoaded = true;
              deptInfo.users = res;
              return res.map(function (user) {
                var name = user.name,
                  id = user.id;
                var userValue = [].concat(_toConsumableArray(deptInfo.deptParentIdPath), [deptInfo.deptId, user.id]).join(STAFF_SELECTOR_PATH_DIVIDER);
                var userDictValue = {
                  name: name || null,
                  userId: id,
                  userValue: userValue,
                  parentDeptInfo: deptInfo
                };
                userInfoDict["".concat(deptId).concat(STAFF_SELECTOR_PATH_DIVIDER).concat(id)] = userDictValue;
                return {
                  type: 'user',
                  name: name || null,
                  value: userValue
                };
              });
            });
          }));
        case 8:
          usersList = _context.sent;
          if (!usersList.every(function (users) {
            return users.length === 0;
          })) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", null);
        case 11:
          nextDtsState.dts = updateTreeDts({
            dts: dts,
            deptIds: needLoadDeptIds,
            deptInfoDict: deptInfoDict,
            usersList: usersList
          });
          return _context.abrupt("return", nextDtsState);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getUserByDeptIds(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var convertDeptApiRespToDts = function convertDeptApiRespToDts(option) {
  var deptApiData = option.deptApiData;
  var walk = function walk(option) {
    var deptApiData = option.deptApiData,
      deptInfoDict = option.deptInfoDict,
      dtsResult = option.dtsResult,
      parentDeptIdPath = option.parentDeptIdPath,
      parentDeptValuePath = option.parentDeptValuePath;
    var _iterator2 = _createForOfIteratorHelper(deptApiData),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        var currentNodePath = parentDeptIdPath.concat(item.deptId);
        var currentNodePathValue = currentNodePath.join(STAFF_SELECTOR_PATH_DIVIDER);
        var dictValue = {
          name: item.departmentName || null,
          deptId: item.deptId,
          deptValue: currentNodePathValue,
          deptParentIdPath: _toConsumableArray(parentDeptIdPath),
          deptParentValuePath: _toConsumableArray(parentDeptValuePath),
          usersLoaded: false,
          users: [],
          total: item.count
        };
        deptInfoDict[item.deptId] = dictValue;
        var deptDtsItem = {
          type: 'dept',
          value: currentNodePathValue,
          name: item.departmentName || null,
          children: [],
          load_option: 1
        };
        dtsResult.push(deptDtsItem);
        if (item.children.length) {
          walk({
            deptApiData: item.children,
            dtsResult: deptDtsItem.children,
            deptInfoDict: deptInfoDict,
            parentDeptIdPath: currentNodePath,
            parentDeptValuePath: parentDeptValuePath.concat(currentNodePathValue)
          });
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return {
      dts: dtsResult,
      deptInfoDict: deptInfoDict
    };
  };
  return walk({
    deptApiData: deptApiData,
    dtsResult: [],
    deptInfoDict: {},
    parentDeptIdPath: [],
    parentDeptValuePath: []
  });
};
export var toastCommonError = function toastCommonError() {
  var error = new Error();
  console.error('错误信息', error.stack);
  message.error(COMMON_INTERNAL_ERROR_MSG);
};
export var getValueLastId = function getValueLastId(value) {
  var id = value.split(STAFF_SELECTOR_PATH_DIVIDER).pop() || null;
  if (!id) {
    toastCommonError();
    return '-1';
  }
  return id;
};
var treeNodeCls = 'zhb-ui-staff-selector-tree-node';
export var useRenderTreeNode = function useRenderTreeNode(props) {
  var corpId = props.corpId;
  var renderTreeNode = useMemoizedFn(function (props) {
    var iconContent = props.iconContent,
      treeNode = props.treeNode,
      indeterminate = props.indeterminate,
      isChecked = props.isChecked,
      onChange = props.onChange,
      onClick = props.onClick;
    var openId = getValueLastId(treeNode.value);
    var nameNode = React.createElement("span", {
      className: "".concat(treeNodeCls, "-name-inner")
    }, treeNode.name ? treeNode.name : React.createElement(ZhbWecomOpenData, {
      type: treeNode.type === 'dept' ? 'departmentName' : 'userName',
      openId: openId,
      corpId: corpId
    }));
    var cls = classNames(_defineProperty(_defineProperty({}, treeNodeCls, true), "".concat(treeNodeCls, "-active"), treeNode.type === 'dept' && treeNode.isExpand));
    var checkboxLabelClick = function checkboxLabelClick(e) {
      if (treeNode.type === 'dept') {
        e.stopPropagation();
        onClick(e);
      }
    };
    var labelContent = React.createElement("ul", {
      className: "".concat(treeNodeCls, "-checkbox-label"),
      onClick: checkboxLabelClick,
      "data-value": treeNode.value,
      "data-deeplevel": treeNode.deepLevel
    }, React.createElement("li", {
      title: treeNode.name || '',
      className: "".concat(treeNodeCls, "-name")
    }, nameNode), iconContent ? React.createElement("li", {
      className: "".concat(treeNodeCls, "-arrow")
    }, iconContent) : null);
    return React.createElement("div", {
      className: cls,
      "data-value": treeNode.value,
      "data-deeplevel": treeNode.deepLevel,
      onClick: onClick
    }, React.createElement(SpaCheckbox, {
      className: "".concat(treeNodeCls, "-checkbox"),
      indeterminate: indeterminate,
      checked: isChecked,
      value: treeNode.value,
      onChange: onChange,
      label: labelContent
    }));
  });
  return {
    renderTreeNode: renderTreeNode
  };
};
export var getDelSelectValue = function getDelSelectValue(prevValue, item) {
  var idx = prevValue.findIndex(function (val) {
    if (val.type !== item.type) {
      return false;
    }
    if (item.type === 'dept' || val.type === 'dept') {
      return item.id === val.id;
    }
    return item.id === val.id && item.parentId === val.parentId;
  });
  if (idx !== -1) {
    var nextSelValue = _toConsumableArray(prevValue);
    nextSelValue.splice(idx, 1);
    return nextSelValue;
  }
  return null;
};
export var getSelValueKey = function getSelValueKey(item) {
  return item.type === 'dept' ? item.id : item.id + item.parentId;
};
export var getExpandNodeValues = function getExpandNodeValues(option) {
  var value = option.value,
    deptInfoDict = option.deptInfoDict;
  var maxLevel = -1;
  var expandNodeValues = [];
  value.forEach(function (item) {
    if (item.type === 'user') {
      var deptInfo = deptInfoDict[item.parentId];
      if (!deptInfo) {
        console.warn("\u672A\u627E\u5230\u7528\u6237\u6240\u5728\u90E8\u95E8id, \u90E8\u95E8\u53EF\u80FD\u5DF2\u7ECF\u5220\u9664: ".concat(item.parentId));
        return;
      }
      if (deptInfo.deptParentIdPath.length > maxLevel) {
        maxLevel = deptInfo.deptParentIdPath.length;
        expandNodeValues = [].concat(_toConsumableArray(deptInfo.deptParentValuePath), [deptInfo.deptValue]);
      }
    }
  });
  return expandNodeValues;
};